import {
  Box,
  Button,
  CircularProgress,
  IconButton,
  Typography
} from '@mui/material';
import { UpgradeAgencyModalTexts } from './AllTexts';
import { useEffect, useState } from 'react';
import {
  buyKeywordAddon,
  getAddon,
  getCreditDetails,
  getPlanDetails,
  getSubscriptionDetailsStripe,
  upgradeDowngradePlan,
  validateCoupon
} from 'src/common/Scraper';
import {
  localStorageMethod,
  openNewTab
} from 'src/common/config/FunctionHelper';
import { UpgradeAgencyPlanModalSxs } from './UpgradeAgencyPlanModalSx';
import { RootState } from 'src/redux/store';
import { useDispatch, useSelector } from 'react-redux';
import { setStateStripeSubscription } from 'src/redux/userReducer';
import CommonAlert from 'src/common/CommonAlert';
import CloseIcon from '@mui/icons-material/Close';
import { AvatarGroupModule } from 'src/common/AvatarGroupsModule';
import { setIsOpenChangePlan } from 'src/redux/siteAuditReducer';
import { changePlanTextNew, paths } from 'src/common/config/TextMessage';
import { useNavigate } from 'react-router';
import { setIsAgencyMonitoring } from 'src/redux/dashboard';
import useIsMobile from 'src/common/CheckDevice';
import { setIsAgencyUpgrade } from 'src/redux/keywordResearch';
import { keywordTrackingUpgradeTexts } from '../keywordResearch/keywordTracking/KeywordTrackingAllTexts';
import CouponSection from './CouponSection';
import { setIsLocalSEOAddonBuy } from 'src/redux/counterSlice';
import { updateSearchesDetailsAndLimits } from 'src/common/config/FunctionHelperPartTwo';

export const UpgradeAgencyPlanModal = ({
  handleCloseUpgradeModal,
  isKeywordTracking = false,
  isBackLink = false,
  isBackLinkUnlock = false,
  isKeywordUnlock = false,
  isMapRankTracking = false,
  isLocalSeoUnlock = false,
  isLocalSeo = false,
  isPro = false,
  isAiUnlock = false
}) => {
  let subscriptionDetails: any =
    useSelector((state: RootState) => state.user.subscription) ?? {};

  const [allPlan, setAllPlan]: any = useState([]);
  const [monthlyPlan, setMonthlyPlan]: any = useState([]);
  const [yearlyPlan, setYearlyPlan]: any = useState([]);
  const [planId, setPlanId]: any = useState(null);
  const [loading, setLoading] = useState(null);
  const [upgradeLoading, setUpgradeLoading] = useState(null);
  const [responseMessage, setResponseMessage]: any = useState(null);
  // Add these state variables at the top with your other useState declarations
  const [couponCode, setCouponCode] = useState('');
  const [couponLoading, setCouponLoading] = useState(false);
  const [couponError, setCouponError] = useState('');
  const [appliedCoupon, setAppliedCoupon] = useState(null);
  const [discountedPrice, setDiscountedPrice]: any = useState(null);
  const userDetails: any = useSelector(
    (state: RootState) => state.counter.userDetails
  );
  const userEmail = useSelector((state: RootState) => state.counter.userEmail);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  const isMapRankingUnlock = isMapRankTracking && isLocalSeoUnlock;
  const isUnlock =
    isKeywordUnlock ||
    isBackLinkUnlock ||
    isLocalSeoUnlock ||
    isMapRankingUnlock ||
    isAiUnlock;
  useEffect(() => {
    if (isUnlock) {
      getAddonDetails();
    } else {
      getAllPlanDetails();
    }
  }, []);

  //plan name Agency,Designer,LocalSEO,Enterprise,Free
  let planName = 'Agency';

  if (isPro) {
    planName = 'Designer';
  }

  const getAllPlanDetails = async () => {
    setLoading(true);
    const getAllPlanResponse: any = await getPlanDetails(planName);
    const allPlans = getAllPlanResponse?.plans || [];
    setAllPlan(allPlans);

    // Get the first matching plan with a monthly interval
    const monthlyData = allPlans.find(
      (plan) => plan.recurring?.interval === 'month'
    );

    // Get the first matching plan with a yearly interval
    const yearlyData = allPlans.find(
      (plan) => plan.recurring?.interval === 'year'
    );

    setMonthlyPlan(monthlyData);
    setYearlyPlan(yearlyData);
    setPlanId(yearlyData?.id);
    setLoading(null);
  };

  const upgradePlan = async () => {
    setUpgradeLoading(true);
    const payload = {
      email: userDetails?.email || '',
      subscription_id: subscriptionDetails?.subscription_id,
      planId,
      type: 'Upgrade',
      downgradeFeedback: '',
      siteIds: []
    };
    const upgradeDowngradePlanResponse: any = await upgradeDowngradePlan(
      payload
    );
    if (upgradeDowngradePlanResponse?.status == 'success') {
      await getSubScriptionDetails();
    }
    setUpgradeLoading(null);
    setResponseMessage({
      status: upgradeDowngradePlanResponse?.status,
      message: upgradeDowngradePlanResponse?.message
    });
    if (isKeywordTracking || isBackLink || isMapRankTracking) {
      setResponseMessage(null);
      handleCloseUpgradeModal();
    } else {
      setTimeout(() => {
        setResponseMessage(null);
        handleCloseUpgradeModal();
      }, 3000);
    }
  };

  const getSubScriptionDetails = async () => {
    const subscriptionDetailsStripe = await getSubscriptionDetailsStripe();
    if (subscriptionDetailsStripe != undefined) {
      if (isKeywordTracking || isBackLink) {
        getSearchesDetail();
      }
      dispatch(setIsAgencyMonitoring(true));
      dispatch(setStateStripeSubscription(subscriptionDetailsStripe));
      if (isKeywordTracking || isBackLink) {
        dispatch(setIsAgencyUpgrade(true));
        setTimeout(() => {
          dispatch(setIsAgencyUpgrade(false));
        }, 5000);
      }
    } else {
      dispatch(setStateStripeSubscription({}));
    }
  };

  let planFeatureList;

  if (isUnlock) {
    planFeatureList = [
      'Backlink analysis tools (see who links to your site)',
      'Keyword tracking (track exactly where you rank for specific keywords anywhere in the world)'
    ];
  } else if (isKeywordTracking || isBackLink) {
    planFeatureList = [
      'Backlink analysis tools (see who links to your site)',
      'Keyword tracking (track exactly where you rank for specific keywords anywhere in the world)',
      '10 website slots',
      'White-labelled PDF reports (add your logo)',
      'Onboarding call and priority support'
    ];
  } else if (isPro) {
    planFeatureList = [
      'Audit up to 3 sites',
      '200 keyword research credits',
      'Scan draft and password-protected Squarespace web pages',
      'PDF Reports'
    ];
  } else {
    planFeatureList = [
      'Weekly Scheduled Reports and Monitoring',
      '10 Websites',
      'Unlimited Automatic Site Audit',
      '500 searches/month',
      'White-Labelled PDF Reports (Add Your Logo)',
      'Priority Support'
    ];
  }

  const getSearchesDetail = async () => {
    let getSearchesDetail: any = await getCreditDetails();

    if (getSearchesDetail) {
      updateSearchesDetailsAndLimits(getSearchesDetail);
    }
  };

  const getAddonDetails = async () => {
    setLoading(true);
    const type =
      isLocalSeoUnlock || isMapRankingUnlock
        ? 'maprankaddon'
        : isKeywordUnlock
        ? 'keywordaddon'
        : isBackLinkUnlock
        ? 'backlinkaddon'
        : isAiUnlock
        ? 'aiaddon'
        : '';

    const getAddonResponse: any = await getAddon(true, type);
    const allPlans = getAddonResponse?.plans || [];
    setAllPlan(allPlans);
    // Get the first matching plan with a monthly interval
    const monthlyData = allPlans.find(
      (plan) => plan.metadata?.interval === 'monthly'
    );

    // Get the first matching plan with a yearly interval
    const yearlyData = allPlans.find(
      (plan) => plan.metadata?.interval === 'yearly'
    );
    setMonthlyPlan(monthlyData);
    setYearlyPlan(yearlyData);
    setPlanId(yearlyData?.id);
    setLoading(null);
  };

  const buyAddOnClick = async () => {
    try {
      setUpgradeLoading(true);
      let response: any = await buyKeywordAddon({
        email: userEmail,
        planId: planId,
        couponId: couponCode ? couponCode : null
      });
      setResponseMessage({
        status: response?.status,
        message: response?.message
      });
      if (response?.status == 'success') {
        if (response?.redirectUrl) {
          window.location.href = response?.redirectUrl;
        }
        if (isLocalSeoUnlock || isMapRankingUnlock) {
          dispatch(setIsLocalSEOAddonBuy(true));
        }
      }
      setTimeout(async () => {
        if (response?.status == 'success') {
          await getCreditDetailApi();
          handleCloseUpgradeModal();
        }
        setResponseMessage(null);
        setUpgradeLoading(null);
      }, 3000);
    } catch (err) {
      handleCloseUpgradeModal();
      setUpgradeLoading(null);
    }
  };

  // Hit the get-credit-details api
  const getCreditDetailApi = async () => {
    let getSearchesDetail: any = await getCreditDetails();
    if (getSearchesDetail) {
      updateSearchesDetailsAndLimits(getSearchesDetail);
    }
  };

  // Function to remove applied coupon
  const removeCoupon = () => {
    setCouponCode('');
    setAppliedCoupon(null);
    setDiscountedPrice(null);
    setCouponError('');
  };

  // Add this function to validate and apply coupon
  const validateAndApplyCoupon = async () => {
    if (!couponCode.trim()) {
      setCouponError('Please enter a coupon code');
      return;
    }

    setCouponLoading(true);
    setCouponError('');

    try {
      const payload = {
        couponId: couponCode?.trim(),
        planId: planId
      };
      const response: any = await validateCoupon(payload);

      const result = response?.data;
      if (response?.status === 'success') {
        setAppliedCoupon(result?.coupon || couponCode?.trim());
        setDiscountedPrice(result);
        setCouponError('');
      } else {
        setCouponError(response?.message || 'Invalid coupon code');
        setAppliedCoupon(null);
        setDiscountedPrice(null);
      }
    } catch (error) {
      setCouponError('Failed to validate coupon. Please try again.');
      setAppliedCoupon(null);
      setDiscountedPrice(null);
    } finally {
      setCouponLoading(false);
    }
  };

  return (
    <>
      {loading ? (
        <Box sx={UpgradeAgencyPlanModalSxs?.loadingBoxSx}>
          <CircularProgress size={35} />
        </Box>
      ) : (
        <Box sx={UpgradeAgencyPlanModalSxs?.mainContainerSx}>
          <Box
            sx={{
              width: { xs: '100%', ms: isUnlock ? '100%' : '60%' },
              ...UpgradeAgencyPlanModalSxs?.firstContainerSx
            }}
          >
            <Box sx={UpgradeAgencyPlanModalSxs?.titleBoxSx}>
              <Typography sx={UpgradeAgencyPlanModalSxs?.titleSx}>
                {isLocalSeoUnlock || isMapRankingUnlock
                  ? keywordTrackingUpgradeTexts?.unlockLocalSeoBtn
                  : isBackLinkUnlock
                  ? keywordTrackingUpgradeTexts?.unlockBackLinkBtn
                  : isKeywordUnlock
                  ? keywordTrackingUpgradeTexts?.unlockBtn
                  : isPro
                  ? UpgradeAgencyModalTexts?.proTitle
                  : isAiUnlock
                  ? UpgradeAgencyModalTexts?.aiTitle
                  : UpgradeAgencyModalTexts?.title}
              </Typography>
              {(isMobile || isUnlock) && (
                <IconButton
                  onClick={handleCloseUpgradeModal}
                  disableRipple
                  aria-label="close"
                  sx={UpgradeAgencyPlanModalSxs?.iconBtnSx}
                >
                  <CloseIcon />
                </IconButton>
              )}
            </Box>
            <Typography sx={UpgradeAgencyPlanModalSxs?.descSx}>
              {isLocalSeoUnlock || isMapRankTracking || isLocalSeo
                ? UpgradeAgencyModalTexts?.localSeoDescription
                : isKeywordTracking
                ? UpgradeAgencyModalTexts?.keywordTrackingDescription
                : isBackLink
                ? UpgradeAgencyModalTexts?.backLinkDescription
                : isPro
                ? UpgradeAgencyModalTexts?.descriptionPro
                : isAiUnlock
                ? UpgradeAgencyModalTexts?.descriptionAi
                : UpgradeAgencyModalTexts?.description}
            </Typography>
            <Box sx={UpgradeAgencyPlanModalSxs?.billingBox}>
              <Typography sx={UpgradeAgencyPlanModalSxs?.billingCycle}>
                {UpgradeAgencyModalTexts?.billingCycle}
              </Typography>
              <Box
                onClick={() => {
                  setPlanId(yearlyPlan?.id);
                }}
                className="mb-3"
                sx={{
                  ...UpgradeAgencyPlanModalSxs?.timelineBoxSx,
                  border:
                    planId == yearlyPlan?.id
                      ? '2px solid var(--color-secondary)'
                      : '2px solid var(--color-border-medium)'
                }}
              >
                <Box>
                  <Typography
                    sx={UpgradeAgencyPlanModalSxs?.timelineBoxTitleSx}
                  >
                    {UpgradeAgencyModalTexts?.annually}
                  </Typography>
                  <Box sx={UpgradeAgencyPlanModalSxs?.typoBoxSx}>
                    <Typography
                      className="mt-2"
                      sx={UpgradeAgencyPlanModalSxs?.timelineBoxTextSx}
                    >
                      <span style={UpgradeAgencyPlanModalSxs?.spanAmountSx}>
                        {`$${
                          appliedCoupon
                            ? Number(
                                (
                                  ((yearlyPlan?.unit_amount || 0) / 12 / 100) *
                                  0.75
                                )
                                  .toFixed(3)
                                  .slice(0, -1)
                              ).toFixed(2)
                            : Number(
                                ((yearlyPlan?.unit_amount || 0) / 12 / 100)
                                  .toFixed(3)
                                  .slice(0, -1)
                              ).toFixed(2)
                        }`}
                      </span>
                      {'/month '}{' '}
                      <span
                        style={UpgradeAgencyPlanModalSxs?.spanCheckedAmount}
                      >
                        {isUnlock
                          ? `$${(monthlyPlan?.unit_amount / 100)?.toFixed(2)}`
                          : yearlyPlan?.metadata?.checktext?.replace('/mo', '')}
                      </span>{' '}
                    </Typography>
                    {yearlyPlan?.metadata?.discount && (
                      <Box sx={UpgradeAgencyPlanModalSxs?.discountBox}>
                        <span style={UpgradeAgencyPlanModalSxs?.discountSpan}>
                          {`Save ${yearlyPlan?.metadata?.discount}`}
                        </span>
                      </Box>
                    )}
                    {yearlyPlan?.metadata?.version == 'v2' && (
                      <Box
                        sx={UpgradeAgencyPlanModalSxs?.absoluteTextSx}
                      >
                        <span
                          style={{
                            fontSize: '12px',
                            fontWeight: 600,
                          }}
                        >
                          &#127881; {changePlanTextNew?.monthsFree}
                        </span>
                      </Box>
                    )}
                  </Box>
                </Box>
                <Box>
                  {planId == yearlyPlan?.id && (
                    <img
                      draggable={false}
                      src={
                        process.env.PUBLIC_URL +
                        `/static/images/icons/checkmark-circle.svg`
                      }
                      alt="Check Icon"
                    />
                  )}
                </Box>
              </Box>
              <Box
                onClick={() => {
                  setPlanId(monthlyPlan?.id);
                }}
                className="mb-3"
                sx={{
                  ...UpgradeAgencyPlanModalSxs?.timelineBoxSx,
                  border:
                    planId == monthlyPlan?.id
                      ? '2px solid var(--color-secondary)'
                      : '2px solid var(--color-border-medium)'
                }}
              >
                <Box>
                  <Typography
                    sx={UpgradeAgencyPlanModalSxs?.timelineBoxTitleSx}
                  >
                    {UpgradeAgencyModalTexts?.monthly}
                  </Typography>
                  <Box sx={UpgradeAgencyPlanModalSxs?.typoBoxSx}>
                    <Typography
                      className="mt-2"
                      sx={UpgradeAgencyPlanModalSxs?.timelineBoxTextSx}
                    >
                      <span style={UpgradeAgencyPlanModalSxs?.spanAmountSx}>
                        {`$${
                          appliedCoupon
                            ? Number(
                                (((monthlyPlan?.unit_amount || 0) / 100) * 0.75)
                                  .toFixed(3)
                                  .slice(0, -1)
                              ).toFixed(2)
                            : Number(
                                ((monthlyPlan?.unit_amount || 0) / 100)
                                  .toFixed(3)
                                  .slice(0, -1)
                              ).toFixed(2)
                        }`}
                      </span>
                      {'/month '}{' '}
                    </Typography>
                  </Box>
                </Box>
                <Box>
                  {planId == monthlyPlan?.id && (
                    <img
                      draggable={false}
                      src={
                        process.env.PUBLIC_URL +
                        `/static/images/icons/checkmark-circle.svg`
                      }
                      alt="Check Icon"
                    />
                  )}
                </Box>
              </Box>
            </Box>
            {responseMessage?.status && (
              // <Alert severity="success">{successMessage}</Alert>
              <CommonAlert
                severity={responseMessage?.status}
                message={responseMessage?.message}
                sx={UpgradeAgencyPlanModalSxs?.alertSx}
              />
            )}
            {/* Add Coupon Section for specific conditions */}
            {(isLocalSeoUnlock || isMapRankingUnlock) && (
              <CouponSection
                couponCode={couponCode}
                setCouponCode={setCouponCode}
                couponError={couponError}
                couponLoading={couponLoading}
                appliedCoupon={appliedCoupon}
                discountedPrice={discountedPrice}
                validateAndApplyCoupon={validateAndApplyCoupon}
                removeCoupon={removeCoupon}
                isAnnual={planId == yearlyPlan?.id}
                isButtonDisabled={false}
              />
            )}

            <Button
              fullWidth
              variant="contained"
              onClick={() => {
                if (!upgradeLoading) {
                  if (
                    isBackLinkUnlock ||
                    isKeywordUnlock ||
                    isLocalSeoUnlock ||
                    isMapRankingUnlock ||
                    isAiUnlock
                  ) {
                    buyAddOnClick();
                  } else {
                    upgradePlan();
                  }
                }
              }}
            >
              {upgradeLoading ? (
                <CircularProgress size={24} color="inherit" />
              ) : isBackLinkUnlock ||
                isKeywordUnlock ||
                isLocalSeoUnlock ||
                isMapRankingUnlock ? (
                UpgradeAgencyModalTexts?.purchaseText
              ) : (
                UpgradeAgencyModalTexts?.upgradeText
              )}
            </Button>
          </Box>
          {!isKeywordUnlock &&
            !isBackLinkUnlock &&
            !isLocalSeoUnlock &&
            !isAiUnlock && (
              <Box sx={UpgradeAgencyPlanModalSxs?.secondContainerSx}>
                <Box sx={UpgradeAgencyPlanModalSxs?.joiBoxSx}>
                  <Typography sx={UpgradeAgencyPlanModalSxs?.joiDescSx}>
                    {UpgradeAgencyModalTexts?.joinDesc}
                  </Typography>
                  {!isMobile && (
                    <IconButton
                      onClick={handleCloseUpgradeModal}
                      disableRipple
                      aria-label="close"
                      sx={UpgradeAgencyPlanModalSxs?.iconBtnSx}
                    >
                      <CloseIcon />
                    </IconButton>
                  )}
                </Box>
                <Box sx={UpgradeAgencyPlanModalSxs?.avatarGroupBoxSx}>
                  <AvatarGroupModule />
                </Box>
                <Box sx={UpgradeAgencyPlanModalSxs?.listBoxSx}>
                  <Typography sx={UpgradeAgencyPlanModalSxs?.listTitleSx}>
                    {isPro
                      ? UpgradeAgencyModalTexts?.listTitleForPro
                      : UpgradeAgencyModalTexts?.listTitle}
                  </Typography>
                  <Box sx={UpgradeAgencyPlanModalSxs?.listSubBoxSx}>
                    {planFeatureList.map((feature, index) => (
                      <Box
                        key={index}
                        sx={UpgradeAgencyPlanModalSxs?.listFeatureBoxSx}
                      >
                        <img
                          draggable={false}
                          src={
                            process.env.PUBLIC_URL +
                            `/static/images/icons/check-icon-blue.svg`
                          }
                          alt="Check Icon"
                        />
                        <Typography
                          sx={UpgradeAgencyPlanModalSxs?.listFeatureTextSx}
                        >
                          {feature}
                        </Typography>
                      </Box>
                    ))}
                    <Box sx={UpgradeAgencyPlanModalSxs?.learnMoreBoxSx}>
                      <Typography
                        onClick={() => {
                          dispatch(setIsOpenChangePlan(true));
                          localStorageMethod('set', 'open_pricing', 'true');
                          openNewTab(paths?.billing);
                        }}
                        sx={UpgradeAgencyPlanModalSxs?.learnMoreSx}
                      >
                        {UpgradeAgencyModalTexts?.learnMore}
                      </Typography>
                      <img
                        draggable={false}
                        src={
                          process.env.PUBLIC_URL +
                          `/static/images/icons/green-up-icon.svg`
                        }
                        alt="Check Icon"
                        onClick={() => {
                          dispatch(setIsOpenChangePlan(true));
                          localStorageMethod('set', 'open_pricing', 'true');
                          openNewTab(paths?.billing);
                        }}
                        style={UpgradeAgencyPlanModalSxs?.greenUpImgStyle}
                      />
                    </Box>
                  </Box>
                </Box>
              </Box>
            )}
        </Box>
      )}
    </>
  );
};
